<template>
  <main
    :class="b()"
    class="l-content-container"
  >
    <div :class="b('content', { withFavoritesBasket: !hideFavoritesBasket })">
      <c-notification-container />
      <slot></slot>
    </div>
    <c-favorites-basket v-if="!hideFavoritesBasket" />
  </main>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import useNotificationStore from '@/stores/notification';
  import cFavoritesBasket from '@/components/c-favorites-basket.vue';
  import cNotificationContainer from '@/components/c-notification-container.vue';

  type Setup = {
    notificationStore: ReturnType<typeof useNotificationStore>;
  };

  export default defineComponent({
    name: 'l-default',

    components: {
      cNotificationContainer,
      cFavoritesBasket,
    },

    props: {
      /**
       * Whether to render c-favorites-basket or not
       * should f.e. never be rendered on l-favorites-overview
       */
      hideFavoritesBasket: {
        type: Boolean,
        default: () => false,
      },
    },

    setup(): Setup {
      return {
        notificationStore: useNotificationStore(),
      };
    },
    // data() {
    //   return {};
    // },

    // computed: {},
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    mounted() {
      this.getNotificationsFromStorage();
    },
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    methods: {
      /**
       * Gets localStorage messages and pushes them in the notification store to display.
       */
      getNotificationsFromStorage() {
        try {
          const messages = window.localStorage.getItem('vueNotification');
          const messagesParsed = messages ? JSON.parse(messages) : null;

          if (Array.isArray(messagesParsed) && messagesParsed.length) {
            messagesParsed.forEach((element) => {
              this.notificationStore.showNotification(element);
            });

            // Clears the localStorage notifications.
            window.localStorage.removeItem('vueNotification');
          }
        } catch {
          throw new Error('An error occurred why retrieving messages from the localStorage.');
        }
      },
    },
    // render() {},
  });
</script>

<style lang="scss">
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';

  .l-default {
    display: flex;
    flex-direction: column;
    margin-top: var(--theme-header-height);

    &__content {
      @include mixins.layout;

      background: variables.$va-color-grayscale--1000;

      &--with-favorites-basket {
        margin-bottom: 3rem;
      }
    }

    .c-notification-container {
      @include mixins.z-index(globalNotification);

      position: fixed;
    }
  }
</style>
